import { glideConfig } from "../gallery/_glide-slider";

function initializeHomepageNewsStack() {
    const glideRoot = document.querySelector("[data-headline-stack] .glide");
    if (!glideRoot) return;

    const slidesUl = glideRoot.querySelector(".glide__slides");
    if (!slidesUl) return;

    const bulletsContainer = glideRoot.querySelector(".glide__bullets");
    const containerEl =
        glideRoot.closest("[data-homepage-news-stack-plugin]") || glideRoot;

    const getItemsPerSlide = () => {
        const width = window.innerWidth;
        return width >= 768 && width < 1024 ? 6 : 7;
    };

    const collectItems = () => {
        const anchors = glideRoot.querySelectorAll(
            ".glide__slides a[data-testid='link--headline-stack-article']",
        );
        return Array.from(anchors, (anchor) => {
            const linkClone = anchor.cloneNode(true);
            const sibling = anchor.nextElementSibling;
            const dividerClone = sibling ? sibling.cloneNode(true) : null;
            return { link: linkClone, divider: dividerClone };
        });
    };

    const buildSlides = (items, itemsPerSlide) => {
        const totalSlides = Math.ceil(items.length / itemsPerSlide) || 1;

        const slideNodes = [];
        for (let slideIndex = 0; slideIndex < totalSlides; slideIndex++) {
            const li = document.createElement("li");
            li.className =
                "flex flex-col gap-3 md:gap-4 last:pb-4 glide__slide";

            const start = slideIndex * itemsPerSlide;
            const end = Math.min(start + itemsPerSlide, items.length);
            for (let i = start; i < end; i++) {
                const { link, divider } = items[i];
                li.appendChild(link);
                if (i !== end - 1 && divider) li.appendChild(divider);
            }
            slideNodes.push(li);
        }

        slidesUl.replaceChildren(...slideNodes);

        if (bulletsContainer) {
            const bulletsTotal = Math.ceil(items.length / itemsPerSlide);
            const bulletNodes = Array.from({ length: bulletsTotal }, (_, i) => {
                const btn = document.createElement("button");
                btn.className = "w-2 h-2 rounded-full glide__bullet bg-l1";
                btn.setAttribute("data-glide-dir", `=${i}`);
                btn.setAttribute("aria-label", "pagination");
                return btn;
            });
            bulletsContainer.replaceChildren(...bulletNodes);
        }
    };

    const originalItems = collectItems();
    let appliedItemsPerSlide = -1;

    const mountSliderIfNeeded = () => {
        const current = getItemsPerSlide();
        if (current === appliedItemsPerSlide) return;
        appliedItemsPerSlide = current;

        buildSlides(
            originalItems.map(({ link, divider }) => ({
                link: link.cloneNode(true),
                divider: divider ? divider.cloneNode(true) : null,
            })),
            current,
        );

        glideConfig(glideRoot, {
            type: "slider",
            touchAngle: 45,
            focusAt: 0,
            startAt: 0,
            keyboard: true,
            gap: 10,
            rewind: false,
        });
    };

    // Initial mount
    mountSliderIfNeeded();

    // Observe container size changes (container query behavior)
    if ("ResizeObserver" in window) {
        let scheduled = false;
        const ro = new ResizeObserver(() => {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(() => {
                scheduled = false;
                mountSliderIfNeeded();
            });
        });
        ro.observe(containerEl);
    } else {
        let resizeTimer = null;
        window.addEventListener(
            "resize",
            () => {
                if (resizeTimer) window.clearTimeout(resizeTimer);
                resizeTimer = window.setTimeout(() => {
                    mountSliderIfNeeded();
                }, 150);
            },
            { passive: true },
        );
    }
}

function init() {
    initializeHomepageNewsStack();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}

export { initializeHomepageNewsStack };
